import { createStore } from 'satcheljs';
import FindControlViewState, {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { resetStore } from '../actions/resetFindControlStore';

export interface FindControlStore {
    viewState: FindControlViewState;
}

export const storeInitialViewState = {
    queryString: '',
    shouldShowFindResult: false,
    findResultSet: [],
    findResultType: FindResultType.None,
    findResultHightlightIndex: -1,
    isSearching: false,
    directorySearchType: DirectorySearchType.None,
    findPeopleFeedbackManager: null,
    inForceResolve: false,
};

export const getStore = createStore<FindControlStore>('FindControl', {
    viewState: storeInitialViewState,
});

function resetAndGetStore(): FindControlStore {
    resetStore();
    return getStore();
}

export default resetAndGetStore;
